/* tslint:disable */
/* eslint-disable */
/**
 * lq.api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum ResultStatus {
    NotRequested = 'NotRequested',
    Pending = 'Pending',
    Found = 'Found',
    NotFound = 'NotFound',
    Error = 'Error',
    NoHit = 'NoHit'
}

export function ResultStatusFromJSON(json: any): ResultStatus {
    return ResultStatusFromJSONTyped(json, false);
}

export function ResultStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResultStatus {
    return json as ResultStatus;
}

export function ResultStatusToJSON(value?: ResultStatus | null): any {
    return value as any;
}

